import type { FC } from "react";

type SparkProps = Record<string, never>;

export const Spark: FC<SparkProps> = (_props) => {
  return (
    <svg
      width="54"
      height="48"
      viewBox="0 0 54 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.5 17.2666C28.1576 19.25 21.6328 25.7454 19.6119 34.0788L19.1459 36L18.9769 35.3031C16.781 26.2482 9.60524 19.2435 0.499999 17.2666L1.18829 17.1171C9.90712 15.2241 16.8375 8.61815 19.1459 -7.5857e-07L19.2897 0.536535C21.517 8.85167 28.1252 15.2754 36.5 17.2666Z"
        fill="#A10F04"
      />
      <path
        d="M53.5 30.6333C49.3288 31.625 46.0664 34.8727 45.0559 39.0394L44.823 40L44.7385 39.6515C43.6405 35.1241 40.0526 31.6217 35.5 30.6333L35.8441 30.5586C40.2036 29.612 43.6687 26.3091 44.823 22L44.8948 22.2683C46.0085 26.4258 49.3126 29.6377 53.5 30.6333Z"
        fill="#A10F04"
      />
      <path
        d="M35.5 41.7555C32.7192 42.4167 30.5443 44.5818 29.8706 47.3596L29.7153 48L29.659 47.7677C28.927 44.7494 26.5351 42.4145 23.5 41.7555L23.7294 41.7057C26.6357 41.0747 28.9458 38.8727 29.7153 36L29.7632 36.1788C30.5057 38.9506 32.7084 41.0918 35.5 41.7555Z"
        fill="#A10F04"
      />
    </svg>
  );
};
